<!-- MFITTで電波状況が悪くてAPIエラーになった場合 -->
<template>
  <ItemDialog ref="badReception" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        動作に時間がかかっています。<br />
        時間を置いてからもう一度お試しください。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogBadReception",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const badReception = ref(null);

    const openDialog = () => {
      badReception.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        badReception.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      badReception,
      openDialog,
      closeDialog,
    };
  },
};
</script>
